export default __webpack_public_path__ + "static/media/img5.8e7ad273.jpg";